import { PublicClientApplication } from '@azure/msal-browser';
import { getMsalConfig } from './msalConfig';

/**
 * MSAL instance manager to handle dynamic configuration
 */
class MsalInstanceManager {
  private instance: PublicClientApplication | null = null;

  /**
   * Get or create MSAL instance with app configuration
   */
  getInstance(
    msalTenantId: string,
    msalClientId: string,
    pepsenseUrl: string
  ): PublicClientApplication {
    if (!this.instance) {
      const config = getMsalConfig(msalTenantId, msalClientId, pepsenseUrl);
      this.instance = new PublicClientApplication(config);
    }
    return this.instance;
  }

  /**
   * Reset instance (useful for testing or config changes)
   */
  reset(): void {
    this.instance = null;
  }
}

export const msalInstanceManager = new MsalInstanceManager();
